const UpgradePlan = () => {
  // redirect to new upgrade-plan page if user tries to access old page
  window.location.replace("/app/upgrade-plan");
  return null;
};

export default UpgradePlan;
